export class tPatientModel {

    shopID: number;
    patientID: string;
    patientTypeID: string;
    patientTitle: number;
    patientGender: number;
    patientChiName: string;
    patientSurname: string;
    patientFirstName: string;
    phoneAreaCode: string;
    patientPhone: number;
    patientPhone2: number;
    patientMedCard1: string;
    patientMedCard2: string;
    patientIHKID: string;
    patientDob: Date;
    patientRefereeEmp: string;
    patientRefereePat: string;
    patientRefereeRelation: number;
    patientAddress: string;
    patientEmail: string;
    patientRemark1: string;
    patientRemark2: string;
    patientRemark3: string;
    patientDepositAcct: number;
    patientChangeAcct: number;

    patientKnowFromMedium: string;

    inActive: string;
    lastModifyDatetime: Date;
    lastModifyUserID: string;
    patientCaseDoctorID:string;

}

export class tPatientModel_Encrypted extends tPatientModel {

    patientPhone_str: string;
    patientPhone2_str: string;

    patientIHKID_str: string;
    patientAddress_str: string;
    patientDob_str: string;
    patientNonHKIDHolder:string;

}
